import { type WorkflowNode } from '@blaze-shared/workflow-domain';

import {
  type ConnectorProvider,
  ConnectorProviderRegistry,
} from '../registry/connector-provider.registry';

export class ConnectorProviderFactory {
  static createConnectorProvider<T extends WorkflowNode>(node: T): ConnectorProvider<T> {
    const connectorProviderClass = ConnectorProviderRegistry.getConnectorProvider(node.nodeType);

    return new connectorProviderClass();
  }
}
